module.exports = __webpack_public_path__ + "img/treebu_lg_icon.07aa79d1.png";